import { JsonPipe, NgStyle, NgTemplateOutlet } from '@angular/common';
import {
  AfterContentInit,
  Component,
  ContentChildren,
  EventEmitter,
  Output,
  QueryList,
  TemplateRef,
  input,
  model,
} from '@angular/core';
import { PfxTemplateDirective } from '../../../directive/pfx-template/pfx-template.directive';
import { IconComponent } from '../icon/icon.component';
import { PanelTemplateType, getPanelTemplatesMap } from '../panel';
import { PanelComponent } from '../panel/panel.component';
import { DetailedPanelItem } from './type/detailed-panel-item.type';

@Component({
  selector: 'pfx-detailed-panel',
  imports: [PanelComponent, IconComponent, JsonPipe, NgStyle, NgTemplateOutlet, PfxTemplateDirective],
  templateUrl: './detailed-panel.component.html',
})
export class DetailedPanelComponent implements AfterContentInit {
  public data = input.required<DetailedPanelItem>();

  public collapsed = model<boolean>(true);

  public clickable = input(false);

  @Output() public readonly panelClicked = new EventEmitter<DetailedPanelItem>();

  @ContentChildren(PfxTemplateDirective) protected templates!: QueryList<PfxTemplateDirective>;

  protected PanelTemplateType = PanelTemplateType;

  private panelTemplatesMap = new Map<PanelTemplateType, TemplateRef<unknown>>();

  public ngAfterContentInit(): void {
    this.setPanelTemplates();
  }

  protected handleOnPanelClicked(event: DetailedPanelItem): void {
    if (!this.clickable()) {
      return;
    }

    this.panelClicked.emit(event);
  }

  protected getPanelTemplate(type: PanelTemplateType): TemplateRef<unknown> | undefined {
    return this.panelTemplatesMap.get(type);
  }

  private setPanelTemplates(): void {
    this.panelTemplatesMap = getPanelTemplatesMap(this.templates);
  }
}
